<!-- <app-header></app-header> -->
<div class="container main-layout">
    <!-- <app-sidebar-chatbot></app-sidebar-chatbot> -->
    <div class="assign-container fluid-container">
        <div class="top-right-div">
        <div class="first-top">
            <div class="left-titl-buton ">
                <div class="back-button" (click)="backbutton()">
                    &larr;
                </div>
                <!-- <div class="title">
                    {{traineeDetails.first_name}}`s Sessions
                </div> -->
            </div>
        </div>
        <!-- <div class="second-top">
            <div class="card">
                <div class="card-one">
                    <img class="profile-img"   src="../../../assets/images/JJ_Icon_Person_RGB (3).svg">
                </div>
                <div class="card-two">
                    <span class="ct-1">{{traineeDetails.first_name}}</span> -->
                    <!-- <span class="ct-2">Sales Consultant</span> -->
                    <!-- <span class="ct-3">Joined: --Check--</span> -->
                    <!-- <span class="ct-4">{{traineeDetails.email}}</span> -->
                <!-- </div>
                <div class="card-three"> -->
                    <!-- <div class="ct-1">Chat sessions: {{traineeDetails.session_count}}</div> -->
                    <!-- <div class="cth-2"><span>Assigned: --Check-- </span> <span>Completed: --Check-- </span></div> -->
                    <!-- <div class="ct-1">Roleplay assigned: {{traineeDetails.roleplay_total_count}}</div> -->
                    <!-- <div class="ct-1">Roleplay completed: {{traineeDetails.roleplay_completed}}</div> -->
                    <!-- <div class="cth-2"><span>Assigned: --Check--</span> <span>Completed: {{traineeDetails.roleplay_completed}}</span></div> -->
                <!-- </div>
    
            </div>
        </div> -->
        <div class="top-row">
            <div class="left-titl-buton ">
                <div class="title">
                    Assigned Roleplays
                </div>
            </div>
            <div class="right-filter">
                <input matInput #searchInput  placeholder="Search with ..." class="filter-search" (input)="applyFilter(searchInput.value)">
                <i class="fa fa-search search-icon"></i>
            </div>
            <div *ngIf="showNoSearchResultsMessage">
                No search results found.
            </div>
        </div>
        <div class="bottom-table">
            <div>
               <!--  <table class="assignee-table">
                    <tr>
                        <th class="tab-th">Roleplay</th>
                        <th class="tab-th">Attempt Date</th>
                        <th class="tab-th">Session Duration</th>
                        <th class="tab-th">Score</th>
                        <th class="tab-th">Topic</th>
                        <th class="tab-th">Feedback</th>
                    </tr>
                    <tr>
                        <td class="tab-td">Role-Play</td>
                        <td class="tab-td">Date & Time</td>
                        <td class="tab-td">1 hr</td>
                        <td class="tab-td">70%</td>
                        <td class="tab-td">Impella</td>
                        <td class="tab-td"><button class="view-feed">View and Feedback &#11167;</button></td>
                    </tr>
                    <tr>
                        <td class="tab-td">Role-Play</td>
                        <td class="tab-td">Date & Time</td>
                        <td class="tab-td">1 hr</td>
                        <td class="tab-td">70%</td>
                        <td class="tab-td">Impella</td>
                        <td class="tab-td"><button class="view-feed">View and Feedback &#11167;</button></td>
                    </tr>
                    <tr>
                        <td class="tab-td">Role-Play</td>
                        <td class="tab-td">Date & Time</td>
                        <td class="tab-td">1 hr</td>
                        <td class="tab-td">70%</td>
                        <td class="tab-td">Impella</td>
                        <td class="tab-td"><button class="view-feed">View and Feedback &#11167;</button></td>
                    </tr>
                    <tr>
                        <td class="tab-td">Role-Play</td>
                        <td class="tab-td">Date & Time</td>
                        <td class="tab-td">1 hr</td>
                        <td class="tab-td">70%</td>
                        <td class="tab-td">Impella</td>
                        <td class="tab-td"><button class="view-feed">View and Feedback &#11167;</button></td>
                    </tr>
    
                </table> -->
            
                <table class="assignee-table mat-elevation-z9" mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">
                    <ng-container matColumnDef="chat_type">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                            Scenario Name
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td"> {{element.scenario_name }} </td>
                      </ng-container>
      
                      <ng-container matColumnDef="chat_start_time">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                            Assigned Date
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td"> {{element.assigned_date | date: 'MM-dd-yyyy hh:mm'}} </td>
                      </ng-container>
    
                      <ng-container matColumnDef="chat_topic">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                            Status
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td"> {{element.roleplay_status}}</td>
                      </ng-container>
    
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    
                </table>
                <mat-paginator [pageSizeOptions]="[5, 10, 15, 20]" showFirstLastButtons aria-label="Select page of periodic elements">
                </mat-paginator>
            </div>
        </div>
        </div>
    
    </div>
    </div>